export const GET_STORE_DATA = "GET_STORE_DATA";
export const GET_SINGLE_ITEM_DATA = "GET_SINGLE_ITEM_DATA";
